// menus and menu button
let menuBtnEls    = $('[data-mobile-menu-open]');
let menuCloseEls = $('[data-mobile-menu-close]');

// show menu
menuBtnEls.on('click', function(){
	let thisEl = $(this);
	let menuEl = $('[data-mobile-menu=' + thisEl.attr('data-mobile-menu-open') + ']');

	menuEl.addClass('active');

	// disable scroll
	if(menuEl) {
		$('body').css('overflow-y', 'hidden');
	}
});

// close menu
menuCloseEls.on('click', function(){
	let menuEl = $(this).closest('[data-mobile-menu]');
	
	menuEl.removeClass('active');
	
	// if there are no active mobile menus
	// disable scroll
	let activeMobileMenuEls = $('[data-mobile-menu].active');
	if(!activeMobileMenuEls.length) $('body').css('overflow-y', '');
});
